import React from 'react';

const Centered: React.FC<{ style?: React.CSSProperties }> = props => {
  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};

export default Centered;
